import * as React from 'react'

import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import getTitle from 'modules/documents/components/Documents/getTitle'
import { Folder } from 'modules/documents/hooks/useGetFolders'

interface Props {
  folder?: Folder
  openCreateModal: () => void
}
const EmptyFolders = ({ folder, openCreateModal }: Props) => {
  const description = folder
    ? i18n.t('settings.folders.list.empty.description', { folder_name: getTitle(folder.name) })
    : i18n.t('settings.folders.list.empty.root_description')

  return (
    <Box
      flexDirection="column"
      alignItems="center"
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      borderRadius={{
        all: 'abs008',
      }}
      gap="s16"
      padding="s24"
    >
      <Icon.Large icon="folder" color="grey600"></Icon.Large>
      <Text.Normal weight="semibold">{i18n.t('settings.folders.list.empty.title')}</Text.Normal>
      <Text.Normal>{description}</Text.Normal>
      <Box>
        <Button type="secondary" onClick={openCreateModal} iconName="add">
          {i18n.t('settings.folders.form.add.button')}
        </Button>
      </Box>
    </Box>
  )
}

export default EmptyFolders
